/* ============ MBJ collection variant-image switcher ============ */
(function () {
  'use strict';
  var STOP={edit:1,the:1,shop:1,all:1,collection:1,jewelry:1,stone:1,gem:1,gemstone:1};
  function norm(s){return (s||'').trim().toLowerCase();}
  function tokens(s){
    return norm(s).replace(/['’]/g,'').replace(/[^a-z0-9]+/g,' ').trim().split(' ')
      .filter(Boolean).map(function(t){return t.replace(/s$/,'');})
      .filter(function(t){return !STOP[t];});
  }
  function subset(n,h){return n.length>0 && n.every(function(t){return h.indexOf(t)!==-1;});}
  function labelMatches(label,T){
    if(T.exactNorm) return norm(label)===T.exactNorm;
    return subset(T.fuzzy, tokens(label));
  }
  function fileName(u){return (u||'').split('?')[0].split('/').pop().toLowerCase();}
  function firstFromSrcset(ss){return (ss||'').split(',')[0].trim().split(' ')[0];}
  var OVERRIDES = {};
  function swatchButtons(card){return card.querySelectorAll('.card-product__swatch-item button, card-product-swatch button');}
  function pageLabels(){
    var set={}, out=[];
    document.querySelectorAll('.card-product__swatch-item button, card-product-swatch button')
      .forEach(function(b){var l=b.getAttribute('aria-label')||''; if(l&&!set[l]){set[l]=1;out.push(l);}});
    return out;
  }
  function computeTarget(labels){
    var p=new URLSearchParams(location.search);
    var fval=p.get('filter.v.m.custom.stone')||p.get('filter.p.m.custom.stone')
            ||p.get('filter.v.m.custom.zodiac_sign')||p.get('filter.p.m.custom.zodiac_sign')||'';
    var handle=(document.body.dataset.collection||'').toLowerCase();
    var override=OVERRIDES[handle]||'';
    var hf=override?null:tokens(handle.replace(/-/g,' '));
    var handleT=override?{exactNorm:norm(override),fuzzy:[],sig:norm(override)}
              :(hf&&hf.length?{exactNorm:'',fuzzy:hf,sig:'f:'+hf.join('-')}:null);
    var filterT=fval?{exactNorm:'',fuzzy:tokens(fval),sig:'x:'+norm(fval)}:null;  // loose match for filters
    function any(T){return T&&labels.some(function(l){return labelMatches(l,T);});}
    if(any(handleT)) return handleT;        // dedicated stone collection wins (ignores stray filters)
    if(any(filterT)) return filterT;        // filtered page uses the chosen stone
    if(handleT) return handleT;             // tentative until swatches render
    if(filterT) return filterT;
    return null;
  }
  function mainImg(card){
    var imgs=card.querySelectorAll('img');
    for(var i=0;i<imgs.length;i++){
      var s=imgs[i].currentSrc||imgs[i].getAttribute('src')||imgs[i].getAttribute('srcset')||imgs[i].getAttribute('data-srcset')||'';
      if(/\/cdn\/|shopify/i.test(s)) return imgs[i];
    }
    return imgs[0]||null;
  }
  function findMatch(card,T){
    var btns=swatchButtons(card);
    if(!btns.length) return undefined;
    var hit=null;
    btns.forEach(function(b){ if(!hit && labelMatches(b.getAttribute('aria-label')||'',T)) hit=b; });
    return hit;
  }
  function targetFile(btn){ return fileName(btn.getAttribute('data-src')||firstFromSrcset(btn.getAttribute('data-srcset'))); }
  function imageMatches(card,btn){
    var tf=targetFile(btn); if(!tf) return true;
    var im=mainImg(card); var cf=im?fileName(im.currentSrc||im.getAttribute('src')):'';
    return !!cf && cf===tf;
  }
  function swap(card,btn){
    var ss=btn.getAttribute('data-srcset')||'', sc=btn.getAttribute('data-src')||firstFromSrcset(ss), link=btn.getAttribute('data-link');
    var im=mainImg(card);
    if(im){
      if(ss){ im.setAttribute('srcset',ss); if('srcset' in im.dataset) im.dataset.srcset=ss; }
      if(sc){ im.setAttribute('src',sc); if('src' in im.dataset) im.dataset.src=sc; im.removeAttribute('loading'); }
      var pic=im.closest('picture');
      if(pic) pic.querySelectorAll('source').forEach(function(s){ if(ss){ s.setAttribute('srcset',ss); if('srcset' in s.dataset) s.dataset.srcset=ss; } });
    }
    swatchButtons(card).forEach(function(b){ b.classList.toggle('active', b===btn); });
    var li=btn.closest('.card-product__swatch-item');
    if(li){ card.querySelectorAll('.card-product__swatch-item').forEach(function(x){x.classList.remove('mbj-active');}); li.classList.add('mbj-active'); }
    if(link) card.querySelectorAll('a[href*="/products/"]').forEach(function(a){a.href=link;});
  }
  function enforce(card,T){
    var m=findMatch(card,T);
    if(m===undefined) return;
    if(m===null){ var miss=(parseInt(card.dataset.mbjMiss||'0',10)+1); card.dataset.mbjMiss=miss; return; }
    if(card.dataset.mbjClicked!=='1'){ m.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true,view:window})); card.dataset.mbjClicked='1'; }
    if(!imageMatches(card,m)) swap(card,m);
  }
  function runAll(){
    var T=computeTarget(pageLabels());
    if(!T) return;
    document.querySelectorAll('.card-product').forEach(function(c){ enforce(c,T); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',runAll); else runAll();
  var n=0, fast=setInterval(function(){ n++; runAll(); if(n>=40) clearInterval(fast); }, 250);
  setTimeout(function(){ setInterval(runAll, 1000); }, 10000);
  var t;
  new MutationObserver(function(){ clearTimeout(t); t=setTimeout(runAll,80); })
    .observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
  window.addEventListener('popstate', function(){ document.querySelectorAll('.card-product').forEach(function(c){c.dataset.mbjClicked='';}); runAll(); });
})();

/* ============ Shop The Look – force a specific variant per product (scoped to this section only) ============ */
(function(){
  'use strict';
  var SECTION='.lookbook-slider__products';
  var WANT={
    'gemstone-choker'         : 'Black Onyx',
    'signature-gemstone-ring' : 'Black Widow',
    'signature-necklace'      : 'REPLACE_WITH_STYLE_NAME'   // <-- black square pendant's style name
  };
  function norm(s){return (s||'').trim().toLowerCase();}
  function file(u){return (u||'').split('?')[0].split('/').pop().toLowerCase();}
  function first(ss){return (ss||'').split(',')[0].trim().split(' ')[0];}
  function btns(card){return card.querySelectorAll('.card-product__swatch-item button, card-product-swatch button');}
  function mainImg(card){var i=card.querySelectorAll('img');for(var k=0;k<i.length;k++){var s=i[k].currentSrc||i[k].getAttribute('src')||i[k].getAttribute('srcset')||i[k].getAttribute('data-srcset')||'';if(/\/cdn\/|shopify/i.test(s))return i[k];}return i[0]||null;}
  function handleOf(card){var a=card.querySelector('a[href*="/products/"]');var m=a&&(a.getAttribute('href')||'').match(/\/products\/([^/?#]+)/);return m?m[1].toLowerCase():'';}
  function swap(card,b){
    var ss=b.getAttribute('data-srcset')||'',sc=b.getAttribute('data-src')||first(ss),link=b.getAttribute('data-link');
    var im=mainImg(card);
    if(im){if(ss){im.setAttribute('srcset',ss);if('srcset' in im.dataset)im.dataset.srcset=ss;}if(sc){im.setAttribute('src',sc);if('src' in im.dataset)im.dataset.src=sc;im.removeAttribute('loading');}var p=im.closest('picture');if(p)p.querySelectorAll('source').forEach(function(s){if(ss){s.setAttribute('srcset',ss);if('srcset' in s.dataset)s.dataset.srcset=ss;}});}
    btns(card).forEach(function(x){x.classList.toggle('active',x===b);});
    var li=b.closest('.card-product__swatch-item');if(li){card.querySelectorAll('.card-product__swatch-item').forEach(function(x){x.classList.remove('mbj-active');});li.classList.add('mbj-active');}
    if(link)card.querySelectorAll('a[href*="/products/"]').forEach(function(a){a.href=link;});
  }
  function run(){
    document.querySelectorAll(SECTION).forEach(function(sec){
      sec.querySelectorAll('.card-product').forEach(function(card){
        var want=WANT[handleOf(card)]; if(!want||want.indexOf('REPLACE_')===0) return;
        var hit=null,L=norm(want);
        btns(card).forEach(function(b){if(!hit&&norm(b.getAttribute('aria-label')||'')===L)hit=b;});
        if(!hit) return;
        if(card.dataset.lbClicked!=='1'){hit.dispatchEvent(new MouseEvent('click',{bubbles:true,cancelable:true,view:window}));card.dataset.lbClicked='1';}
        var tf=file(hit.getAttribute('data-src')||first(hit.getAttribute('data-srcset')));
        var im=mainImg(card),cf=im?file(im.currentSrc||im.getAttribute('src')):'';
        if(tf&&cf!==tf) swap(card,hit);
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  var n=0,iv=setInterval(function(){n++;run();if(n>=40)clearInterval(iv);},250);
  setTimeout(function(){setInterval(run,1000);},10000);
  var t;new MutationObserver(function(){clearTimeout(t);t=setTimeout(run,80);}).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset']});
})();